import React from 'react'
import ReactDOM from 'react-dom'
import {LoginModalOverlay} from 'common/styleguide/LoginModalOverlay'
import {ClubPoiEditor} from 'features/recumbent/ClubPoiEditor'
import {GlobalNav} from 'common/GlobalNav'
import {UpgradeModal} from 'features/recumbent/UpgradeModal'
import {Sidebar} from 'features/recumbent/PlannerSidebar'
import {PlannerOnboardingModal} from 'features/recumbent/PlannerOnboardingModal'
import {Gallery} from 'features/gallery/Gallery'
import {RouteSplitter} from 'features/recumbent/RouteSplitter'
import 'lib/hotnessNotifier'
import {CueReviewTool} from 'features/cue_review'
import {LoadExistingApp} from 'features/search/LoadExisting'
import {SaveRouteApp} from 'features/recumbent/SaveRoute'
import {RouteHoverCardLauncher} from 'features/recumbent/RouteHoverCardLauncher'
import {ExportDialog} from 'features/routes/RouteShowPage/dialogs/ExportDialog/ExportDialog'
import {Route} from 'data/records'
import {DataProvider} from 'data/DataProvider'
import {getCurrentUser} from 'lib/utils'
import {bootCoreShim} from './CoreShim'

const {renderWithinCoreShim} = bootCoreShim()

const registerComponentFn = (id, Component) => {
  const unmountComponent = () => {
    const domNode = document.getElementById(id)
    ReactDOM.unmountComponentAtNode(domNode)
  }

  window.rwgps[id] = (props) => {
    const domNode = document.getElementById(id)
    const instance = ReactDOM.render(<Component unmountComponent={unmountComponent} {...props} />, domNode)
    return {instance, unmountComponent}
  }
}

const registerComponentNode = (name, Component) => {
  window.rwgps[name] = (node, props) => {
    const unmountComponent = () => {
      ReactDOM.unmountComponentAtNode(node)
    }

    const instance = ReactDOM.render(<Component unmountComponent={unmountComponent} {...props} />, node)

    return {instance, unmountComponent}
  }
}

const registerModalComponent = (name, Component) => {
  const id = `react-${name}`
  const getDomNode = () => {
    const node = document.getElementById(id)
    if (node) {
      return node
    }
    const div = document.createElement('div')
    div.id = id
    document.body.appendChild(div)
    return div
  }
  const unmount = () => {
    const node = getDomNode()
    ReactDOM.unmountComponentAtNode(node)
  }

  window.rwgps[name] = (props) => {
    const domNode = getDomNode()
    ReactDOM.render(<Component {...props} onRequestClose={unmount} />, domNode)
  }
}

// SSR Components
renderWithinCoreShim('globalnav-ssr', <GlobalNav />)

// Components that extend the window.rwgps API
registerComponentFn('plannerSidebar', Sidebar)
registerComponentFn('cueReviewTool', CueReviewTool)
registerComponentFn('routeSplitter', RouteSplitter)
registerModalComponent('loadExistingModal', LoadExistingApp)
registerModalComponent('saveRouteModal', SaveRouteApp)
registerModalComponent('clubPoiEditor', ClubPoiEditor)
registerModalComponent('loginModalOverlay', LoginModalOverlay)
registerModalComponent('upgradeModal', UpgradeModal)
registerModalComponent('plannerOnboardingModal', PlannerOnboardingModal)
registerModalComponent('gallery', Gallery)
registerModalComponent('advancedExport', ({legacyRoute, ...props}) => {
  const currentUser = getCurrentUser()
  const routeOverride = legacyRoute && Route.deserialize(legacyRoute).set('_permissions', {customize_export_options: currentUser.accountLevel > 0})
  return <DataProvider>
    <ExportDialog troute={routeOverride} objectType='route' {...props} />
  </DataProvider>
})
registerComponentNode('routeHoverCard', RouteHoverCardLauncher)
